export const environment = {
  production: true,
  urlApi: 'https://www.weddingsmart.it',
  urlImage: 'https://www.weddingsmart.it/portal/assets/',
  clientPaypal: 'AZWyxNK8VoD6mmIu2PwI0VH5Uibx3pybD250iNxVGAhihhpIDoBdkM1g4byXUVAv9QPAfyS22r2zpx0R',
  googleAnalytics: 'G-Z76CGGSK1X'
};
